/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cut_Aria_LabelInputs */

const en_cut_aria_label = /** @type {(inputs: Cut_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cut selected events or text`)
};

const fr_cut_aria_label = /** @type {(inputs: Cut_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couper les evenements ou le texte selectionnes`)
};

const de_cut_aria_label = /** @type {(inputs: Cut_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählte Ereignisse oder Texte ausschneiden`)
};

const it_cut_aria_label = /** @type {(inputs: Cut_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taglia gli eventi o il testo selezionati`)
};

const ru_cut_aria_label = /** @type {(inputs: Cut_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вырезать выделенные события или текст`)
};

const es_cut_aria_label = /** @type {(inputs: Cut_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cortar eventos o texto seleccionados`)
};

const zh_cn2_cut_aria_label = /** @type {(inputs: Cut_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`剪切选定的事件或文本`)
};

const ja_cut_aria_label = /** @type {(inputs: Cut_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントまたはテキストを切り取る`)
};

const hi_cut_aria_label = /** @type {(inputs: Cut_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित घटनाओं या पाठ को काटें`)
};

const pt_pt2_cut_aria_label = /** @type {(inputs: Cut_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recortar eventos ou texto selecionados`)
};

/**
* | output |
* | --- |
* | "Cut selected events or text" |
*
* @param {Cut_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const cut_aria_label = /** @type {((inputs?: Cut_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cut_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_cut_aria_label(inputs)
	if (locale === "de") return de_cut_aria_label(inputs)
	if (locale === "it") return it_cut_aria_label(inputs)
	if (locale === "ru") return ru_cut_aria_label(inputs)
	if (locale === "es") return es_cut_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_cut_aria_label(inputs)
	if (locale === "ja") return ja_cut_aria_label(inputs)
	if (locale === "hi") return hi_cut_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_cut_aria_label(inputs)
	return en_cut_aria_label(inputs)
});